import { EFoundBySearchTermSourceId } from "@tm/models"

export const foundBySearchTermButtonText = (
    foundBySearchTermSourceId: EFoundBySearchTermSourceId | undefined,
    translateText: (key: number | string) => string
): string => {
    switch (foundBySearchTermSourceId) {
        case EFoundBySearchTermSourceId.UniversalArticleSearch:
            return translateText(14088)
        case EFoundBySearchTermSourceId.VehicleProductGroupSearch:
            return translateText(14089)
        case EFoundBySearchTermSourceId.ArticleDirectSearch:
        default:
            return translateText(389)
    }
}

export const getSearchUrlForSearchTermSourceId = (
    foundBySearchTermSourceId: EFoundBySearchTermSourceId | undefined,
    articleSearchUrl: string,
    universalPartSearchUrl: string,
    vehiclesPartSearchUrl: string
) => {
    switch (foundBySearchTermSourceId) {
        case EFoundBySearchTermSourceId.UniversalArticleSearch:
            return universalPartSearchUrl
        case EFoundBySearchTermSourceId.VehicleProductGroupSearch:
            return vehiclesPartSearchUrl
        case EFoundBySearchTermSourceId.ArticleDirectSearch:
        default:
            return articleSearchUrl
    }
}
